import * as Accordion from '@radix-ui/react-accordion';
import { ChevronDown } from 'lucide-react';
import { Reveal, Eyebrow } from './Reveal';
import { FAQS, BRAND } from '../config/site';

export const FAQ = () => (
  <section id="faq" className="ks-faq scroll-mt-24 py-20 lg:py-28">
    <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-[1fr_1.4fr] lg:gap-20 lg:px-8">
      <Reveal>
        <Eyebrow>FAQ</Eyebrow>
        <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-navy sm:text-4xl lg:text-5xl">
          Questions, Answered
        </h2>
        <p className="mt-5 max-w-md text-base leading-relaxed text-charcoal sm:text-lg">
          Everything you need to know about working with KINDSTONE. For anything else,{' '}
          <a
            href={BRAND.smsHref}
            data-testid="faq-text-link"
            className="font-bold text-electric transition-colors hover:text-navy"
          >
            text us at {BRAND.smsDisplay}
          </a>
          .
        </p>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion.Root type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <Accordion.Item
              key={f.q}
              value={`item-${i}`}
              className="rounded-2xl border border-navy/10 bg-white shadow-soft"
              data-testid={`faq-item-${i + 1}`}
            >
              <Accordion.Header>
                <Accordion.Trigger className="group flex w-full items-center justify-between gap-6 px-6 py-6 text-left text-lg font-bold text-navy transition-colors hover:text-electric sm:text-xl">
                  {f.q}
                  <span className="shrink-0 text-electric transition-transform duration-300 group-data-[state=open]:rotate-180">
                    <ChevronDown size={20} aria-hidden="true" />
                  </span>
                </Accordion.Trigger>
              </Accordion.Header>
              <Accordion.Content className="overflow-hidden data-[state=closed]:animate-none">
                <p className="max-w-2xl px-6 pb-7 text-base leading-relaxed text-charcoal">{f.a}</p>
              </Accordion.Content>
            </Accordion.Item>
          ))}
        </Accordion.Root>
      </Reveal>
    </div>
  </section>
);

export default FAQ;
